import { Suspense, lazy } from 'react'
import { Switch, Redirect } from 'react-router-dom'
import { common, layouts } from '@ocean/ui'
import { PublicRoute } from 'routing/components'
import authRoutes from 'modules/Auth/routing/routes'
import routes from './routes'

const { Decorator, RouteChangeProgress } = common
const { PageLayout, PageSegment } = layouts

export { routes }

export const SsoLogin = lazy(
  () => import(/* webpackChunkName: "SsoLogin" */ 'modules/Sso/pages/SsoLogin')
)

export const SsoConfirm = lazy(
  () => import(/* webpackChunkName: "SsoConfirm" */ 'modules/Sso/pages/SsoConfirm')
)

export const SsoLogout = lazy(
  () => import(/* webpackChunkName: "SsoLogout" */ 'modules/Sso/pages/SsoLogout')
)

const SsoRouting = () => (
  <Suspense fallback={<RouteChangeProgress />}>
    <PageLayout>
      <PageSegment segmentId='content'>
        <Decorator backgroundColor='oceanSidebar' textColor='white'>
          <Switch>
            <PublicRoute exact path={routes.login} component={SsoLogin} />
            <PublicRoute exact path={routes.confirm} component={SsoConfirm} />
            <PublicRoute exact path={routes.logout} component={SsoLogout} />
            <Redirect path='*' to={authRoutes.login} />
          </Switch>
        </Decorator>
      </PageSegment>
    </PageLayout>
  </Suspense>
)

export default SsoRouting
